import { callApi } from '@local_modules/generic/fetch.js'
import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'

export async function showDuplicateJournalNumbers (accountingOrganisationId) {
  const url = '/api/data-review/entity-journals-duplicate/:accountingOrganisationId'
  const apiResponse = await callApi(url, {
    accountingOrganisationId
  })
  console.log('apiResponse', apiResponse)

  // const duplicateJournalNumbers = apiResponse?.map(record => record.number)
  const duplicateJournalNumbers = apiResponse?.reduce(function (accumulator, record) {
    accumulator[record.number] = accumulator[record.number] || {
      journalNumber: record.number,
      count: 0,
      records: []
    }
    accumulator[record.number].count++
    accumulator[record.number].records.push(record)
    return accumulator
  }, {})
  console.log('duplicateJournalNumbers', duplicateJournalNumbers)

  if (duplicateJournalNumbers.length === 0) {
    setElementHtml('duplicateJournalNumbers', 'No duplicate journal numbers')
  } else {
    const listOfDuplicates = Object.values(duplicateJournalNumbers)?.map(function (record) {
      console.log(record)
      return `${record.journalNumber} (x${record.count})`
    }).join(', ')
    console.log('listOfDuplicates', listOfDuplicates)
    setElementHtml('duplicateJournalNumbers', `<span class="tag is-warning">${apiResponse?.length}</span> [<a href="/app/admin/entity/${accountingOrganisationId}/journals-duplicates">Details</a>] ${listOfDuplicates}`)
  }
}
